import script from "./SearchResult.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchResult.vue?vue&type=script&setup=true&lang=js"

import "./SearchResult.vue?vue&type=style&index=0&id=4b09282c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b09282c"]])

export default __exports__